import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { CameraConfigState } from '../../components/wizard-configuration/wizard-configuration.component';
import { EdgeCamera } from '../../../../cameras/camera.model';
import { CameraStorageSettingsTabComponentV2 } from '../../../../pages/location-v2/pages/device/pages/device-list/components/camera-storage-settings-tab/camera-storage-settings-tab-v2.component';
import { cameraTypeStr } from '@models/camera.model';

export interface ConfigureCamerasDialogData {
    cameras: CameraConfigState[];
}

@Component({
    selector: 'app-configure-cameras-dialog',
    templateUrl: './configure-cameras-dialog.component.html',
    styleUrls: ['./configure-cameras-dialog.component.scss'],
    standalone: false
})
export class ConfigureCamerasDialogComponent implements OnInit {

    public cameraTypeStr = cameraTypeStr;

    @ViewChild('storageSettings') storageSettings: CameraStorageSettingsTabComponentV2;

    public cameras: CameraConfigState[] = [];
    public CameraType = EdgeCamera.CameraType;

    // Form values
    public selectedCameraType: EdgeCamera.CameraType = EdgeCamera.CameraType.StaticCamera;
    public audioEnabled = false;
    public audioMainStreamEnabled: boolean = false;
    public audioSubStreamEnabled: boolean = false;
    public autoConfigure: boolean = true;

    private updatedStorage: any = {};


    constructor(
        public dialogRef: MatDialogRef<ConfigureCamerasDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: ConfigureCamerasDialogData
    ) {
        this.cameras = data.cameras;
    }

    ngOnInit(): void {
        // Initialize with default values from first camera if available
        if (this.cameras.length > 0) {
            const firstCamera = this.cameras[0];
            this.selectedCameraType = firstCamera.cameraType || EdgeCamera.CameraType.StaticCamera;
            this.autoConfigure = firstCamera.autoConfigure || false;
            // Audio settings would be read from camera document if available
        }
    }

    // Storage settings change handler
    public onStorageChanged(): void {
        this.updatedStorage = this.storageSettings?.updatedStorage || {};
    }

    public toggleAudio() {
        this.audioMainStreamEnabled = this.audioEnabled;
        this.audioSubStreamEnabled = this.audioEnabled;
    }

    // Save changes
    public onSave(): void {
        // Apply changes to ALL cameras
        this.cameras.forEach(camera => {
            // Update camera type
            camera.cameraType = this.selectedCameraType;

            // Update auto-configure
            camera.autoConfigure = this.autoConfigure;

            // Update audio settings on the config state (used in buildFullCameraDocument)
            camera.audioMainStreamEnabled = this.audioMainStreamEnabled;
            camera.audioSubStreamEnabled = this.audioSubStreamEnabled;

            // Update storage settings if present in updatedStorage
            if (this.updatedStorage.storageMaxDays !== undefined && this.updatedStorage.storageMaxDays !== '') {
                camera.storageMaxDays = Number(this.updatedStorage.storageMaxDays);
            }

            if (this.updatedStorage.storageStream) {
                camera.storageFromSubstream = this.updatedStorage.storageStream.storageFromSubstream;
            }

            if (this.updatedStorage.smartStorage) {
                camera.smartStorageEnabled = this.updatedStorage.smartStorage.enabled;
            }
        });

        this.dialogRef.close(this.cameras);
    }

    public onCancel(): void {
        this.dialogRef.close();
    }


}
